import variableQueries from '../queries/variableQueries'

export default function createVariableMap(queryResults) {
  const variableQueryKeys = Object.keys(variableQueries)

  return variableQueryKeys.reduce((acc, variableKey) => ({ ...acc, [variableKey]: queryResults[variableKey][variableQueries[variableKey]] }), {})
}
